/**
 * 动态加载外部脚本 / 样式（按需加载）。
 *
 * 背景：index.html 原先用 document.write 同步加载 OSS / 上传 / 分享 / 富文本等库，
 * 每个页面（含首页）都加载，且带 timestamp 导致无法缓存。
 * 改为按需加载后，首页 / 详情页不再加载这些库；用到时（发布、分享）才动态注入。
 *
 * 特性：
 * - 同一 URL 只加载一次，重复调用返回同一个 Promise（缓存）。
 * - 已存在相同 src 的 script 标签时复用，不重复注入。
 * - 加载失败会清掉缓存，允许后续重试。
 */
const scriptCache = {};

export function loadScript(src) {
    if (scriptCache[src]) return scriptCache[src];
    scriptCache[src] = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${src}"]`);
        if (existing) {
            if (existing.dataset.loaded === '1') return resolve();
            existing.addEventListener('load', () => {
                existing.dataset.loaded = '1';
                resolve();
            });
            existing.addEventListener('error', () => {
                delete scriptCache[src];
                reject(new Error('load script failed: ' + src));
            });
            return;
        }
        const s = document.createElement('script');
        s.src = src;
        s.type = 'text/javascript';
        s.charset = 'utf-8';
        s.onload = () => { s.dataset.loaded = '1'; resolve(); };
        s.onerror = () => {
            delete scriptCache[src];
            s.parentNode && s.parentNode.removeChild(s);
            reject(new Error('load script failed: ' + src));
        };
        document.head.appendChild(s);
    });
    return scriptCache[src];
}

export function loadStyle(href) {
    if (document.querySelector(`link[href="${href}"]`)) return Promise.resolve();
    return new Promise((resolve) => {
        const l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = href;
        l.onload = resolve;
        l.onerror = resolve; // 样式加载失败不阻塞业务
        document.head.appendChild(l);
    });
}
